import {
    CLOSED,
    OPEN,
    KEYFRAMETARGETS,
} from "@km/animations/animationFactory";

import {EnumDictionary} from  "@k/js/delme_globals";

export enum LOGOMODULE_POSSIBLE_STATES {
    closed="closed",
    logoverwaltung="verwaltung",
    logoList="list",
    library="library",
    userlibrary="userlibrary",
    edit="edit",
    color="color",
    stocklogoLibrary="stocklogoLibrary",
    kilogoLibrary="kilogoLibrary"
}

export type LogoModuleTargetState = {
    list: KEYFRAMETARGETS,
    edit: KEYFRAMETARGETS,
    color: KEYFRAMETARGETS,
    colorShade: KEYFRAMETARGETS,
    verwaltung: KEYFRAMETARGETS
    library:KEYFRAMETARGETS,
    userlibrary:KEYFRAMETARGETS,
    stockLogoLibrary:KEYFRAMETARGETS,
    kiLogoLibrary:KEYFRAMETARGETS
}

export const LogoModulBackTarget:EnumDictionary<LOGOMODULE_POSSIBLE_STATES, LOGOMODULE_POSSIBLE_STATES> = {
    [LOGOMODULE_POSSIBLE_STATES.closed]:LOGOMODULE_POSSIBLE_STATES.closed,
    [LOGOMODULE_POSSIBLE_STATES.logoverwaltung]:LOGOMODULE_POSSIBLE_STATES.closed,
    [LOGOMODULE_POSSIBLE_STATES.logoList]:LOGOMODULE_POSSIBLE_STATES.logoverwaltung,
    [LOGOMODULE_POSSIBLE_STATES.library]:LOGOMODULE_POSSIBLE_STATES.logoverwaltung,
    [LOGOMODULE_POSSIBLE_STATES.stocklogoLibrary]:LOGOMODULE_POSSIBLE_STATES.library,
    [LOGOMODULE_POSSIBLE_STATES.edit]:LOGOMODULE_POSSIBLE_STATES.logoverwaltung,
    [LOGOMODULE_POSSIBLE_STATES.color]:LOGOMODULE_POSSIBLE_STATES.edit,
    [LOGOMODULE_POSSIBLE_STATES.kilogoLibrary]:LOGOMODULE_POSSIBLE_STATES.library,
    [LOGOMODULE_POSSIBLE_STATES.userlibrary]:LOGOMODULE_POSSIBLE_STATES.userlibrary,
};

export const LOGOMODULE_TARGET_STATES:EnumDictionary<LOGOMODULE_POSSIBLE_STATES, LogoModuleTargetState> = {
    [LOGOMODULE_POSSIBLE_STATES.closed]: {
        library:CLOSED,
        userlibrary:CLOSED,
        list: CLOSED,
        edit: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        verwaltung: CLOSED,
        stockLogoLibrary:CLOSED,
        kiLogoLibrary:CLOSED
    },
    [LOGOMODULE_POSSIBLE_STATES.logoverwaltung]: {
        library:CLOSED,
        userlibrary:CLOSED,
        list: CLOSED,
        edit: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        verwaltung: OPEN,
        stockLogoLibrary:CLOSED,
        kiLogoLibrary:CLOSED
    },
    [LOGOMODULE_POSSIBLE_STATES.logoList]: {
        library:CLOSED,
        userlibrary:CLOSED,
        list: OPEN,
        edit: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        verwaltung: CLOSED,
        stockLogoLibrary:CLOSED,
        kiLogoLibrary:CLOSED
    },
    [LOGOMODULE_POSSIBLE_STATES.library]: {
        library:OPEN,
        userlibrary:CLOSED,
        list: CLOSED,
        edit: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        verwaltung: CLOSED,
        stockLogoLibrary:CLOSED,
        kiLogoLibrary:CLOSED
    },
    [LOGOMODULE_POSSIBLE_STATES.userlibrary]: {
        library:CLOSED,
        userlibrary:OPEN,
        list: CLOSED,
        edit: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        verwaltung: CLOSED,
        stockLogoLibrary:CLOSED,
        kiLogoLibrary:CLOSED
    },
    [LOGOMODULE_POSSIBLE_STATES.stocklogoLibrary]: {
        library:CLOSED,
        userlibrary:CLOSED,
        list: CLOSED,
        edit: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        verwaltung: CLOSED,
        stockLogoLibrary:OPEN,
        kiLogoLibrary:CLOSED
    },
    [LOGOMODULE_POSSIBLE_STATES.kilogoLibrary]: {
        library:CLOSED,
        userlibrary:CLOSED,
        list: CLOSED,
        edit: CLOSED,
        color: CLOSED,
        colorShade: CLOSED,
        verwaltung: CLOSED,
        stockLogoLibrary:CLOSED,
        kiLogoLibrary:OPEN
    },
    [LOGOMODULE_POSSIBLE_STATES.edit]: {
        library:CLOSED,
        userlibrary:CLOSED,
        list: CLOSED,
        edit: OPEN,
        color: CLOSED,
        colorShade: CLOSED,
        verwaltung: CLOSED,
        stockLogoLibrary:CLOSED,
        kiLogoLibrary:CLOSED
    },
    [LOGOMODULE_POSSIBLE_STATES.color]: {
        library:CLOSED,
        userlibrary:CLOSED,
        list: CLOSED,
        edit: OPEN,
        color: OPEN,
        colorShade: OPEN,
        verwaltung: CLOSED,
        stockLogoLibrary:CLOSED,
        kiLogoLibrary:CLOSED
    }
}
